var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modals-controller"},[_vm._l((_vm.activeModals),function(modal,idx){return [_c(modal.type,_vm._b({key:idx,tag:"component"},'component',modal.props,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }